import * as React from 'react';
import { Box, Grid, InputBaseComponentProps, TextField } from '@mui/material';

interface GridFormTextFieldProps {
  size: number;
  name: string;
  label: string;
  required: boolean;
  value: string | undefined;
  type?:string|undefined;
  disabled?:boolean|undefined;
  inputProps?:InputBaseComponentProps|undefined;
  helperText?:string|undefined;
  onChange: (value: string, field:string, error:boolean) => void;
  checkError: (name: string, required: boolean, value: string | undefined) => boolean;
}

const GridFormTextField: React.FC<GridFormTextFieldProps> = ({
    disabled, inputProps, helperText, size, name, label, required, value, onChange, checkError,type
}) => {
  return (
    <Grid item xs={size}>
      <TextField name={name} label={label}
        value={value} error={checkError(name, required, value)}
        onChange={(ev) => {
            const error  = checkError(name, required, ev.target.value);
            onChange(ev.target.value, name, error);
        }}
        disabled={disabled}
        variant="standard" fullWidth required={required}
        type={type} inputProps={inputProps}
        helperText={helperText}
        InputLabelProps={{shrink: !!value}}
      />
    </Grid>
  );
};

interface FlexIconTextFieldProps {
  size: number;
  name: string;
  label: string;
  icon?: JSX.Element;
  required: boolean;
  value: string | undefined;
  type?:string|undefined;
  disabled?:boolean|undefined;
  inputProps?:InputBaseComponentProps|undefined;
  helperText?:string|undefined;
  onChange: (value: string, field:string, error:boolean) => void;
  checkError: (name: string, required: boolean, value: string | undefined) => boolean;
}

export const FlexIconFormTextField: React.FC<FlexIconTextFieldProps> = ({
    icon, disabled, inputProps, helperText, size, name, label, required, value, onChange, checkError,type
}) => {
  return (
    <>
    {
      icon ?
      <Box sx={{ minWidth: 34, display: 'flex', justifyContent: 'center', alignItems: 'center', mt:'8px' }}>
          {icon}
      </Box>
      : <></>
    }
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <TextField name={name} label={label}
        value={value} error={checkError(name, required, value)}
        onChange={(ev) => {
            const error  = checkError(name, required, ev.target.value);
            onChange(ev.target.value, name, error);
        }}
        disabled={disabled}
        variant="standard" fullWidth required={required}
        type={type} inputProps={inputProps}
        helperText={helperText}
        InputLabelProps={{shrink: !!value}}
      />
    </Box>
    </>
  );
};

export default GridFormTextField;